import React from 'react';

import { TextInput } from './text-input';

function PhoneInput(props) {
  // adicionar formatação de telefone (via input adornment start?) e formatação do valor
  // no onChange e no display.
  return <TextInput {...props} type="tel" />;
}

export { PhoneInput };
